@if (appSelectorVisible()) {
    <st-app-selector />
}

<div class="st-side-bar-outside-container">
    <div class="st-side-bar-header-container">
        <mat-toolbar>
            <!-- <span>{{ this.application | titlecase }}</span> -->
            <span class="st-side-bar__app-label">{{ languageSettings.PSTWebApStorytellingTitleLabel }}</span>
            <span class="st-side-bar-spacer"></span>
            <button
                mat-icon-button
                [matTooltip]="languageSettings.PSTWebPlanningViewsLabel"
                [routerLink]="['/PST', appName, 'planning_views']">
                <mat-icon class="material-symbols-outlined">dashboard_customize</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-side-bar-header-icon__lock"
                [matTooltip]="lockUnlockTooltip"
                (click)="toggleEditMode()">
                @if (!inEditMode()) {
                    <mat-icon>lock</mat-icon>
                }
                @if (inEditMode()) {
                    <mat-icon class="material-symbols-outlined">lock_open</mat-icon>
                }
            </button>
        </mat-toolbar>
    </div>
    @if (!isWastebin()) {
        <mat-accordion multi>
            @for (group of groups(); track group?.ID) {
                <mat-expansion-panel
                    class="st-side-bar-group"
                    togglePosition="before"
                    cdkDropListGroup
                    [expanded]="group.Opened"
                    [dir]="isRTL"
                    [class.st-side-bar-system]="group.System"
                    (afterExpand)="onOpened(group)"
                    (afterCollapse)="onClosed(group)">
                    <mat-expansion-panel-header
                        class="st-side-bar-group-header"
                        [class.st-side-bar-system]="group.System">
                        @if (!group?.Team || isEditDisabled(group)()) {
                            <div class="st-side-bar-group-label">
                                {{ group?.Label }}
                            </div>
                        }
                        @if (group?.Team && !isEditDisabled(group)()) {
                            <div class="st-side-bar-group-label">
                                <mat-select
                                    class="st-side-bar-group-label-select"
                                    [value]="currentTeam()"
                                    (click)="$event.stopPropagation()"
                                    (selectionChange)="onCurrentTeamChanged($event)">
                                    @for (team of playbookTeams(); track team.ID) {
                                        <mat-option [value]="team.ID">
                                            {{ team.Description }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </div>
                        }
                        @if (!isEditDisabled(group)()) {
                            <button
                                class="st-side-bar-group-button-options"
                                st-click-stop-propagation
                                mat-icon-button
                                [matTooltip]="languageSettings.PSTWebNewSectionLabel"
                                [disabled]="isEditDisabled(group)()"
                                (click)="createNewSection(group)">
                                <mat-icon>add</mat-icon>
                            </button>
                        }
                    </mat-expansion-panel-header>
                    @for (section of group.Items; track section?.ID) {
                        <mat-expansion-panel
                            class="st-side-bar-section"
                            hideToggle
                            cdkDropList
                            [expanded]="section.Opened"
                            [class.st-section-new]="section.InEditMode"
                            [class.st-side-bar-system]="group.System"
                            [disabled]="inEditMode()"
                            (afterExpand)="onOpened(group, section)"
                            (afterCollapse)="onClosed(group, section)"
                            (cdkDropListDropped)="onDrop($event, group, section)">
                            @if (section.InEditMode) {
                                <st-section-label
                                    class="st-section-label"
                                    [section]="section"
                                    (cancelEdit)="onCancelSection(group, $event)"
                                    (save)="onSaveSection(group, $event)" />
                            }
                            @if (!section.InEditMode) {
                                <mat-expansion-panel-header
                                    inner
                                    class="st-side-bar-section-header">
                                    @if (section.Opened) {
                                        <mat-icon
                                            class="st-side-bar-section-icon"
                                            small>
                                            folder_open
                                        </mat-icon>
                                    }
                                    @if (!section.Opened) {
                                        <mat-icon
                                            class="st-side-bar-section-icon"
                                            small>
                                            folder
                                        </mat-icon>
                                    }
                                    <st-section-label
                                        class="st-section-label"
                                        [section]="section" />

                                    <span class="st-side-bar-spacer"></span>

                                    @if (isCreateViewStateEnabled(group)()) {
                                        <button
                                            class="st-side-bar-section-button-options"
                                            st-click-stop-propagation
                                            mat-icon-button
                                            [disabled]="inEditMode()"
                                            [matTooltip]="languageSettings.PSTWebPlusButtonLabel"
                                            (click)="createViewState(group, section)">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    }

                                    @if (!isEditDisabled(group)()) {
                                        <button
                                            class="st-side-bar-section-button-options"
                                            st-click-stop-propagation
                                            mat-icon-button
                                            [disabled]="inEditMode()"
                                            [matTooltip]="languageSettings.PSTWebRenameRemoveTitle"
                                            [matMenuTriggerFor]="menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                    }

                                    <mat-menu #menu="matMenu">
                                        <ng-template matMenuContent>
                                            <button
                                                mat-menu-item
                                                [disabled]="isEditDisabled(group)()"
                                                (click)="renameSection(group, section)">
                                                {{ languageSettings.PSTWebRenameLabel }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                [disabled]="isEditDisabled(group)()"
                                                (click)="removeSection(group, section)">
                                                {{ languageSettings.PSTWebRemoveLabel }}
                                            </button>
                                        </ng-template>
                                    </mat-menu>
                                </mat-expansion-panel-header>
                            }
                            @for (item of section.Items; track item?.Guid) {
                                <div
                                    class="st-side-bar-item"
                                    routerLinkActive="st-side-bar-item--selected"
                                    cdkDrag
                                    [routerLink]="item.Url"
                                    [class.st-side-bar-system]="group.System"
                                    [class.st-side-bar-item-drag-enabled]="inEditMode() && dragEnabled(group)"
                                    [class.st-side-bar-item-drag-disabled]="inEditMode() && !dragEnabled(group)"
                                    [cdkDragDisabled]="!dragEnabled(group)"
                                    [cdkDragData]="item.Guid"
                                    [matTooltip]="item.Label"
                                    (click)="navigationItemClick()">
                                    @if (inEditMode()) {
                                        <mat-icon
                                            class="st-side-bar-section-icon-drag-handle"
                                            fontSet="material-symbols-outlined"
                                            small>
                                            drag_handle
                                        </mat-icon>
                                    }
                                    <mat-icon
                                        class="st-side-bar-section-icon"
                                        fontSet="material-symbols-outlined"
                                        small />
                                    <div class="st-side-bar-item-label">{{ item.Label }}</div>
                                    <button
                                        class="st-side-bar-item-button-options"
                                        st-click-stop-propagation
                                        mat-icon-button
                                        [matTooltip]="languageSettings.PSTWebViewSettingsTitle"
                                        [matMenuTriggerFor]="menu"
                                        [disabled]="inEditMode()">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu
                                        #menu="matMenu"
                                        class="st-side-bar-menu">
                                        <ng-template matMenuContent>
                                            @if (group.ID === navigationGroupTypes.Global) {
                                                <button
                                                    mat-menu-item
                                                    [disabled]="isEditDisabled(group)()"
                                                    (click)="makeGlobalDefaultViewState($event, item)">
                                                    {{ makeGlobalDefaultViewLabel() }}
                                                </button>
                                            }
                                            @if (group.ID === navigationGroupTypes.Team) {
                                                <button
                                                    mat-menu-item
                                                    [disabled]="isEditDisabled(group)()"
                                                    (click)="makeTeamDefaultViewState($event, item)">
                                                    {{ makeTeamDefaultViewLabel() }}
                                                </button>
                                            }
                                            <button
                                                mat-menu-item
                                                (click)="makeDefaultViewState($event, item)">
                                                {{ makeDefaultViewLabel() }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                [disabled]="isEditDisabled(group)()"
                                                (click)="editViewState(group, section, item)">
                                                {{ languageSettings.PSTWebEditViewLabel }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                disabled>
                                                {{ languageSettings.PSTWebDuplicateLabel }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                disabled>
                                                {{ languageSettings.PSTWebDuplicateAsTeamViewLabel }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                class="st-side-bar-menu-delete"
                                                [disabled]="isEditDisabled(group)()"
                                                (click)="deleteViewState(group, section, item)">
                                                {{ languageSettings.PSTWebDeleteViewState }}
                                            </button>
                                        </ng-template>
                                    </mat-menu>
                                </div>
                            }
                        </mat-expansion-panel>
                    }
                </mat-expansion-panel>
                @if (!$last) {
                    <mat-divider [class.st-side-bar-system]="group.System" />
                }
            }
        </mat-accordion>
    }
</div>
